import React from "react";
import useStyles from './styles';
import CheckedIcon from "../../../../images/icons/checked-icon.svg";
import InfoIcon from '../../../../images/icons/info.svg';

const FormCard = (props) => {
  const classes = useStyles();
  const { titulo, children, hasError } = props;
  return (
    <div className={classes.formularioCorpo}>
      <div className={classes.quadradoTopoDireita}/>
      <div className={classes.quadradoTopoEsquerda}/>
      <div className={classes.quadradoEsquerdo}/>
      <div className={classes.quadradoDireita}/>
      <div className={classes.quadradoBaixo}/>
      <div className={classes.cabecalho}>
        <img className={classes.imagem} src={hasError ? InfoIcon : CheckedIcon} />
        <p className={classes.formularioTitulo}>{titulo}</p>
      </div>
      { children }
    </div>)
}

export default FormCard;
